import type { FC } from 'react';
import styled from 'styled-components';
import type { Match, WrestlerInMatch } from '../../../types';
import { BoxWinnerGeneric, DefaultContainerCard, TopDecorColor } from './GenericComponentCssMatchCard';
import CenterInfoFightComponentRender from './GenericComponentMatchCard';

// Stili CSS personalizzati per questo componente
const styles = `
  .center-info-fight-component-render-nwo {
    width: 20% !important;
  }
`;

const BoxWrestlersForNwoMatchContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
    width: 40%;
    gap: 30px;
`;

const BoxWrestler = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    width: calc(50% - 30px);

    & .name-wrestler {
        font-size: 12px;
        font-weight: 500;
        margin: 0;
        text-transform: uppercase;
        width: 100%;
        padding: 0 30px;
        // spazio caratteri
        letter-spacing: 5px;
        // se supera il width va a capo
        white-space: normal;
        overflow-wrap: break-word;
    }

    &.box-wrestler.right .name-wrestler {
        text-align: right;
        justify-content: flex-end;
    }
`;

const AvatarWrestler = styled.div`
    position: relative;
    width: 75px;
    height: 75px;
    border: 2px solid rgba(163, 27, 27, 0.45);
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        border-color: rgba(163, 27, 27, 0.85);
        transform: scale(1.1);
    }

    & img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top;
    }
`;

interface NwoMatchCardProps {
    matchInfo: Match;
    keyMatchInfo: number | string;
    navigateToWrestler: (wrestler: WrestlerInMatch) => void;
}

const NwoMatchCard: FC<NwoMatchCardProps> = ({ matchInfo, keyMatchInfo, navigateToWrestler }) => {
    // prendo props.match.wrestlers e lo divido in due array uguale.. se dispari, il primo array avra' un elemento in più
    const wrestlers = matchInfo.wrestlers;
    const wrestlers1 = wrestlers.slice(0, Math.ceil(wrestlers.length / 2));
    const wrestlers2 = wrestlers.slice(Math.ceil(wrestlers.length / 2));

    // renderizza un singolo wrestler
    const renderSingleWrestler = (wrestler: WrestlerInMatch, key: number, side: 'left' | 'right') => {
        if (side === 'left') {
            return (
                <BoxWrestler className={`box-wrestler ${side}`} key={key}>
                    <AvatarWrestler className="avatar-wrestler"
                        onClick={() => navigateToWrestler(wrestler)}
                    >
                        <img src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name} />

                        {wrestler.pivot.is_winner ? (
                            <BoxWinnerGeneric className="box-winner-generic-nwo">
                                <span className="winner-text">WIN</span>
                                {matchInfo.win_by_dq ?
                                    <span className="by-dq">BY DQ</span>
                                : null}
                            </BoxWinnerGeneric>
                        ) : null}
                    </AvatarWrestler>
                    <h6 className="name-wrestler">{wrestler.name}</h6>
                </BoxWrestler>
            );
        } else {
            return (
                <BoxWrestler className={`box-wrestler ${side}`} key={key}>
                    <h6 className="name-wrestler">{wrestler.name}</h6>
                    <AvatarWrestler className="avatar-wrestler"
                        onClick={() => navigateToWrestler(wrestler)}
                    >
                        <img src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name} />

                        {wrestler.pivot.is_winner ? (
                            <BoxWinnerGeneric className="box-winner-generic-nwo">
                                <span className="winner-text">WIN</span>
                                {matchInfo.win_by_dq ?
                                    <span className="by-dq">BY DQ</span>
                                : null}
                            </BoxWinnerGeneric>
                        ) : null}
                    </AvatarWrestler>
                </BoxWrestler>
            );
        }
    };

    return (
        <DefaultContainerCard
         key={keyMatchInfo}
         style={{
            paddingLeft: '30px',
            paddingRight: '30px'
        }}
         className="nwo-match-card">
            <style>{styles}</style>
            <TopDecorColor />

            <BoxWrestlersForNwoMatchContainer className="box-wrestlers-for-nwo-match-container-left">
                {wrestlers1.map((wrestler, key) => (
                    renderSingleWrestler(wrestler, key, 'left')
                ))}
            </BoxWrestlersForNwoMatchContainer>

            <CenterInfoFightComponentRender
                className="center-info-fight-component-render-nwo"
                nameMatch="NWO"
                matchInfo={matchInfo}
            />

            <BoxWrestlersForNwoMatchContainer className="box-wrestlers-for-nwo-match-container-right">
                {wrestlers2.map((wrestler, key) => (
                    renderSingleWrestler(wrestler, key, 'right')
                ))}
            </BoxWrestlersForNwoMatchContainer>
        </DefaultContainerCard>
    );
};

export default NwoMatchCard;
